<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">订单编号</span>
        <Input type="text" v-model="searchParams.id" placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">预约编号</span>
        <Input type="text" v-model="searchParams.reservationNo" placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">客户姓名</span>
        <Input type="text" clearable v-model="searchParams.customerName" placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">兑换商品</span>
        <Select v-model="searchParams.svcId" clearable filterable>
          <Option v-for="(item, index) in serviceList" :value="item.id" :key="index">{{ item.svcName }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">兑换时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          :editable="false"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.orderDate"
          @on-change="searchParams.orderDate = $event"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <div class="tools-box">
      <Tabs v-model="searchParams.orderState" :animated="false" @on-click="searchAjax()">
        <div class="tools-box" slot="extra">
          <Button type="primary" ghost @click="daochu()">导出</Button>
        </div>
        <TabPane label="全部" name="-1"></TabPane>
        <TabPane label="待审核" name="1"></TabPane>
        <TabPane label="已通过" name="2"></TabPane>
        <TabPane label="已驳回" name="3"></TabPane>
        <TabPane label="已退回" name="4"></TabPane>
        <TabPane label="待完成" name="0"></TabPane>
      </Tabs>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <!-- 预约编号 -->
        <template slot-scope="{ row }" slot="reservationNo">
          <span class="table-btn m0" @click="goReservation(row)" v-if="row.reservationNo">{{ row.reservationNo }}</span>
          <span class="table-btn m0 disabled" v-else>未关联</span>
        </template>
        <template slot-scope="{ row }" slot="orderState">
          <span class="my-tag" v-if="row.orderState == 0"> 待完成 </span>
          <span class="my-tag blue" v-if="row.orderState == 1"> 待审核 </span>
          <span class="my-tag green" v-if="row.orderState == 2"> 已通过 </span>
          <span class="my-tag red" v-if="row.orderState == 3"> 已驳回 </span>
          <span class="my-tag org" v-if="row.orderState == 4"> 已退回 </span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <span @click="goDetail(row, 1)" class="table-btn"> 详情 </span>
            <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip left-10" transfer v-if="[3, 4].includes(row.orderState * 1)">
              <span class="table-btn red def">查看原因</span>
              <div slot="content">
                <p>{{ row.remark }}</p>
              </div>
            </Poptip>
            <span @click="goDetail(row, 0)" class="table-btn" v-if="[0, 3].includes(row.orderState * 1)"> 编辑 </span>
            <span @click="del(row)" class="table-btn red" v-if="[0, 3, 4].includes(row.orderState * 1)"> 删除 </span>
          </div>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, common, config],
  components: {
    confirmModal
  },
  data() {
    return {
      // 服务列表
      serviceList: [],
      // 搜索参数
      searchParams: {
        orderState: '-1', // 订单状态，默认全部
        orderDate: [] // 订单日期范围
      }
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.initListParams('/buz/extSvc/order/page');
  },
  activated() {
    this.getServiceList();
    this.getList();
  },
  methods: {
    // 选择保司，查询产品
    getServiceList() {
      this.$http({
        url: '/buz/extSvc/page',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.serviceList = res.data;
      });
    },
    // 跳转预约详情
    goReservation(data) {
      this.openPageTabTags('/operate/appointmentManager/detail', {
        id: data.rid,
        backUrl: '/servicesManager/order',
        time: Date.now()
      });
    },
    reload() {
      this.selectArr = [];
      this.isAll = false;
      this.getList();
    },
    // 设置参数
    setListParams(params) {
      if (params.orderDate && params.orderDate[0]) {
        params.orderDateStart = params.orderDate[0];
        params.orderDateEnd = params.orderDate[1];
      }
      delete params.orderDate;
      if (params.orderState == '-1') {
        delete params.orderState;
      }
      this.getColumns();
    },
    // 跳转详情
    goDetail(row, islook) {
      this.openPageTabTags('/servicesManager/order/editForm', {
        id: row.id,
        svcId: row.svcId,
        backUrl: '/servicesManager/order',
        islook
      });
    },
    // 兑换
    exchange(row) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: `请确认是否兑换${row.svcName}？`
        })
        .then(async () => {
          const list = JSON.parse(JSON.stringify(this.tableData));
          list.splice(index, 1);
          this.save(list);
        });
    },
    // 导出
    daochu() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFun({
        url: '/buz/extSvc/order/list/export',
        type: 'POST',
        params: params
      });
    },
    del(item) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(() => {
          this.$http({
            url: '/buz/extSvc/order/del',
            type: 'GET',
            data: {
              id: item.id
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.getList();
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.ivu-tabs {
  width: 100%;
}
</style>
